<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div class="animated fadeIn" v-if="pageLoaded">
    <b-modal
      id="delJudge"
      ref="delJudge"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>انقضا داور طرح</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-expire) to expiration of the referee -->
            <b-button
              variant="danger"
              size="lg"
              @click="
                delJudge();
                hideModal('delJudge');
              "
              >انقضا</b-button
            >

            <!-- NOTE (b-cancel) to cancel expiration -->
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal('delJudge')"
              >لغو</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      آیا از انقضای داوری مطمئن هستید؟
      <br />
      <br />این کار غیر قابل برگشت خواهد بود!
    </b-modal>
    <b-card
      v-if="role == 'referee' && refereeErrorHandler"
      style="border: 0"
      class="shadow p-3 mb-5 bg-white rounded mt-0"
      >با توجه به وضعیت درخواست، داور اجازه دسترسی به اطلاعات را ندارد</b-card
    >
    <b-card v-else style="border: 0" class="mt-0 mb-0">
      <b-card
        v-if="role == 'referee' && proposal.adminToReferee"
        header-bg-variant="danger"
        header-text-variant="white"
        header="پیام ادمین"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ proposal.adminToReferee }}</b-card
      >
      <h3>کد نشست تخصصی: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت نشست تخصصی: {{ proposal.status }}</h4>
      <hr />
      <b-card
        v-if="
          role == 'researcher' &&
          (proposal.status == 'نیاز به تکمیل / اصلاح' ||
            proposal.status == 'پیش نویس') &&
          proposal.adminMessage
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="اصلاحات مورد نیاز"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ proposal.adminMessage }}</b-card
      >
      <b-card
        v-if="
          (role == 'researcher' || role == 'admin') &&
          proposal.status == 'رد شده است'
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="دلایل رد"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
      >
        <li v-for="message in proposal.rejectionIds" :key="message">
          {{ rejectOptions.filter((x) => x.code == message)[0].label }}
        </li>
      </b-card>
      <b-button
        style="float: left"
        v-if="tabIndex == 0"
        variant="primary"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o"></i>
        دریافت Word
      </b-button>
      <b-tabs pills v-model="tabIndex">
        <b-tab v-if="proposal.requestsCode" title="چکیده دوره‌" active lazy>
          <!-- docx -->
          <div v-show="false" id="doc">
            <div class="all" style="text-align: right">
              <h1
                style="
                  display: inline-block;
                  text-align: center;
                  padding: 5px 0;
                  border-bottom: 3px solid black;
                "
              >
                کد نشست تخصصی:
                <span
                  style="direction: ltr; font-family: Bahnschrift SemiBold"
                  >{{ proposal.requestsCode }}</span
                >
              </h1>
              <div>
                <h2 style="color: black; direction: rtl">
                  تاریخ خروجی:
                  <span style="direction: ltr">{{
                    proposal.registerDate
                  }}</span>
                </h2>
                <hr />
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  عنوان و حمایت‌های پیشین
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.faSubject ? 'done' : 'required'">
                      <strong>عنوان نشست: </strong>{{ proposal.faSubject }}
                    </li>
                    <li
                      :class="
                        proposal.initialIsSupported != null
                          ? 'done'
                          : 'required'
                      "
                    >
                      <strong
                        >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                        استفاده کرده است؟
                      </strong>

                      {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                    </li>

                    <li
                      v-if="proposal.initialIsSupported"
                      :class="
                        proposal.initialSupportedType ? 'done' : 'required'
                      "
                    >
                      <strong> حمایت ها: </strong
                      >{{
                        proposal.initialSupportedType
                          ? options.filter(
                              (x) => x.value == proposal.initialSupportedType
                            )[0].text
                          : ""
                      }}
                    </li>
                    <li
                      v-if="
                        proposal.initialSupportedType == 'other' &&
                        proposal.initialIsSupported
                      "
                      :class="
                        proposal.initialOtherSupport ? 'done' : 'required'
                      "
                    >
                      <strong>عنوان حمایت دریافتی: </strong>
                      {{ proposal.initialOtherSupport }}
                    </li>
                    <li
                      v-if="proposal.initialIsSupported"
                      :class="
                        proposal.initialSupportDescription ? 'done' : 'required'
                      "
                    >
                      <strong>توضیحات حمایت دریافتی: </strong>
                      {{ proposal.initialSupportDescription }}
                    </li>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.meetingSponsors"
                      :fields="sponsorFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات اصلی دوره
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.faSubject ? 'done' : 'required'">
                      <strong>عنوان نشست تخصصی: </strong
                      >{{ proposal.faSubject }}
                    </li>
                    <li :class="proposal.meetingGoals ? 'done' : 'required'">
                      <strong>هدف از برگزاری نشست: </strong
                      >{{ proposal.meetingGoals }}
                    </li>
                    <li :class="proposal.meetingPlace ? 'done' : 'required'">
                      <strong>مکان برگزاری نشست: </strong
                      >{{ proposal.meetingPlace }}
                    </li>
                    <li :class="proposal.universityId ? 'done' : 'required'">
                      <strong>دانشگاه محل برگزاری نشست: </strong>
                      {{
                        proposal.universityId
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li
                      v-if="proposal.universityId == notUniversity"
                      :class="proposal.otherUniversity ? 'done' : 'required'"
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ proposal.otherUniversity }}
                    </li>
                    <li
                      v-if="proposal.mehvarId != notMehvar"
                      :class="proposal.mehvarId ? 'done' : 'required'"
                    >
                      <strong>محور طرح: </strong>
                      {{ mehvarr }}
                    </li>
                    <li
                      v-if="proposal.mehvarId == notMehvar"
                      :class="proposal.mehvarId ? 'done' : 'required'"
                    >
                      <strong>محور طرح: </strong> سایر محورها
                    </li>
                    <li
                      v-if="proposal.mehvarId == notMehvar"
                      :class="proposal.otherMehvars ? 'done' : 'required'"
                    >
                      <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                    </li>
                    <li>
                      <strong>حوزه طرح: </strong>
                      <ul>
                        <li v-if="proposal.zoneMedicine">پزشکی</li>
                        <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                        <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                        <li v-if="proposal.zoneIndustrial">صنعتی</li>
                        <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                        <li v-if="proposal.zoneOther">سایر</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات مجری برگزار کننده نشست
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.researcherName ? 'done' : 'required'">
                      <strong>نام: </strong>{{ proposal.researcherName }}
                    </li>
                    <li
                      :class="proposal.researcherLastName ? 'done' : 'required'"
                    >
                      <strong>نام خانوادگی: </strong
                      >{{ proposal.researcherLastName }}
                    </li>
                    <li
                      :class="proposal.researcherNatCode ? 'done' : 'required'"
                    >
                      <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                    </li>
                    <li
                      :class="proposal.researcherMobile ? 'done' : 'required'"
                    >
                      <strong>تلفن همراه: </strong
                      >{{ proposal.researcherMobile }}
                    </li>
                    <li :class="proposal.researcherFax ? 'done' : 'required'">
                      <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                    </li>
                    <li :class="proposal.researcherEmail ? 'done' : 'required'">
                      <strong>پست الکترونیکی: </strong
                      >{{ proposal.researcherEmail }}
                    </li>
                    <li :class="proposal.researcherState ? 'done' : 'required'">
                      <strong>استان: </strong>{{ proposal.researcherState }}
                    </li>
                    <li :class="proposal.researcherCity ? 'done' : 'required'">
                      <strong>شهر: </strong>{{ proposal.researcherCity }}
                    </li>
                    <li
                      :class="
                        proposal.researcherUniversityId ? 'done' : 'required'
                      "
                    >
                      <strong>دانشگاه محل تحصیل: </strong>
                      {{
                        proposal.researcherUniversityId
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      :class="
                        proposal.researcherUniversityOther ? 'done' : 'required'
                      "
                      v-if="proposal.researcherUniversityId == notUniversity"
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ proposal.researcherUniversityOther }}
                    </li>
                    <li>
                      <strong
                        >دانشگاه محل اشتغال به عنوان عضوهئیت علمی:
                      </strong>
                      {{
                        proposal.researcherUniversityJobId
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityJobId
                            )[0]
                            ? universities.filter(
                                (x) =>
                                  x.id == proposal.researcherUniversityJobId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      :class="
                        proposal.researcherLastDegree ? 'done' : 'required'
                      "
                    >
                      <strong>آخرین مدرک تحصیلی: </strong
                      >{{ proposal.researcherLastDegree }}
                    </li>
                    <li>
                      <strong style="color: blue"
                        >نشست های تخصصی برگزار شده:
                      </strong>
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.researcherMeetings"
                        :fields="meetingFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </li>
                    <li>
                      <strong style="color: blue"
                        >کارگاه های برگزار شده:
                      </strong>
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.researcherWorkshops"
                        :fields="workshopFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  برگزار کنندگان
                </h2>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.colleagues"
                  :fields="organizersFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  زمان‌بندی
                </h2>
                <div>
                  <strong>زمان شروع: </strong>
                  {{
                    proposal.gantData.length > 0
                      ? moment(
                          new Date(
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )
                          )
                        ).format("jDD/jMM/jYYYY")
                      : ""
                  }}
                  <br />
                  <strong>زمان پایان: </strong>
                  {{
                    proposal.gantData.length > 0
                      ? moment(
                          new Date(
                            Math.max(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )
                          )
                        ).format("jDD/jMM/jYYYY")
                      : ""
                  }}
                  <br />
                  <strong>مدت زمان: </strong>
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                  <br />
                </div>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.gantData"
                  :fields="serviceFieldsDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  تعهدات
                </h2>
                <div>
                  <ul>
                    <li v-if="proposal.promiseArrays[0]">
                      با توجه به آیین نامه تمامی مستندات در پایان نشست در سامانه
                      بارگذاری خواهد شد.
                    </li>
                    <li v-if="proposal.promiseArrays[1]">
                      گزارش برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه
                      می شود.
                    </li>
                    <li v-if="proposal.promiseArrays[2]">
                      عکس های برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه
                      می شود می‌باشد.
                    </li>
                    <li v-if="proposal.promiseArrays[3]">
                      پوستر نشست قبل از چاپ به تایید گروه پژوهش خواهد رسید.
                    </li>
                    <li v-if="proposal.promiseArrays[4]">
                      متن خبر پیش از برگزاری جهت درج در سایت به همراه پوستر
                      تایید شده به گروه پژوهش ارسال می شود.
                    </li>
                    <li v-if="proposal.promiseArrays[5]">
                      هماهنگی مناسب با ناظر نشست صورت خواهد گرفت.
                    </li>
                    <li v-if="proposal.promiseArrays[6]">
                      پذیرایی از شرکت کنندگان طبق آیین نامه صورت خواهد گرفت.
                    </li>
                    <li v-if="proposal.promiseArrays[7]">
                      گواهی نامه ها طبق آیین نامه و با هماهنگی گروه پژوهش تهیه و
                      در اختیار شرکت کنندگان قرار می گیرد.
                    </li>
                    <li v-if="proposal.promiseArrays[8]">
                      لینک اخبار و مستندات و گزارش ها روی سامانه بارگذاری خواهد
                      شد.
                    </li>
                    <li v-if="proposal.promiseArrays[9]">
                      کتابچه برگزاری نشست با هماهنگی گروه پژوهش تهیه و در اختیار
                      ستاد قرار می گیرد.
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <!-- docx -->
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-1 variant="dark">
                <h5 class="mb-0">عنوان و حمایت‌های پیشین&nbsp;</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              accordion="my-accordion"
              role="tabpanel"
              visible
            >
              <b-card-body>
                <b-card-text>
                  <ul>
                    <li>
                      <strong class="text-primary">عنوان به زبان فارسی: </strong
                      >{{ proposal.faSubject }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                        استفاده کرده است؟
                      </strong>
                      <b-form-radio-group
                        v-model="proposal.initialIsSupported"
                        disabled
                      >
                        <b-form-radio :value="true">بله</b-form-radio>
                        <b-form-radio :value="false">خیر</b-form-radio>
                      </b-form-radio-group>
                    </li>

                    <li v-if="proposal.initialIsSupported">
                      <strong class="text-primary">حمایت ها: </strong
                      >{{
                        proposal.initialSupportedType
                          ? options.filter(
                              (x) => x.value == proposal.initialSupportedType
                            )[0].text
                          : ""
                      }}
                    </li>
                    <li
                      v-if="
                        proposal.initialSupportedType == 'other' &&
                        proposal.initialIsSupported
                      "
                    >
                      <strong class="text-primary">عنوان حمایت دریافتی: </strong
                      >{{ proposal.initialOtherSupport }}
                    </li>
                    <li v-if="proposal.initialIsSupported">
                      <strong class="text-primary"
                        >توضیحات حمایت دریافتی: </strong
                      >{{ proposal.initialSupportDescription }}
                    </li>
                    <br />
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.meetingSponsors"
                      :fields="sponsorFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1 border-0" role="tab">
              <b-button block v-b-toggle.accordion-2 variant="dark">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات اصلی دوره
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-2"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li>
                      <strong class="text-primary">عنوان نشست تخصصی: </strong
                      >{{ proposal.faSubject }}
                    </li>
                    <li>
                      <strong class="text-primary">هدف از برگزاری نشست: </strong
                      >{{ proposal.meetingGoals }}
                    </li>
                    <li>
                      <strong class="text-primary">مکان برگزاری نشست: </strong
                      >{{ proposal.meetingPlace }}
                    </li>
                    <b-row class="text-primary pt-1 font-weight-bold">
                      <p class="mt-2 mr-2">تاریخ برگزاری بین بازه زمانی</p>
                      <span class="mt-2 mr-2"> {{ proposal.startDate }}</span>
                      <p class="mt-2 mr-2">تا</p>
                      <span class="mt-2 mr-2">{{ proposal.finalDate }}</span>
                      <p class="mt-2 mr-2">می باشد</p>
                    </b-row>
                    <li>
                      <strong class="text-primary"
                        >دانشگاه محل برگزاری نشست:
                      </strong>
                      {{
                        proposal.universityId
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li v-if="proposal.universityId == notUniversity">
                      <strong class="text-primary">نام دانشگاه: </strong
                      >{{ proposal.otherUniversity }}
                    </li>
                    <li v-if="proposal.mehvarId != notMehvar">
                      <strong class="text-primary">محور طرح: </strong>
                      {{ mehvarr }}
                    </li>
                    <li v-if="proposal.mehvarId == notMehvar">
                      <strong class="text-primary">محور طرح: </strong>
                      سایر محورها
                    </li>
                    <li v-if="proposal.mehvarId == notMehvar">
                      <strong class="text-primary">نام محور: </strong
                      >{{ proposal.otherMehvars }}
                    </li>
                    <li>
                      <strong class="text-primary">حوزه طرح: </strong>
                      <b-form-group disabled>
                        <b-form-checkbox v-model="proposal.zoneMedicine"
                          >پزشکی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneAgriculture"
                          >کشاورزی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneEnvironment"
                          >محیط زیست</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneIndustrial"
                          >صنعتی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneBioComputing"
                          >رایانش زیستی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneOther"
                          >سایر</b-form-checkbox
                        >
                      </b-form-group>
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-3 variant="light">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات مجری برگزار کننده نشست
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-3"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li>
                      <strong class="text-primary">نام: </strong
                      >{{ proposal.researcherName }}
                    </li>
                    <li>
                      <strong class="text-primary">نام خانوادگی: </strong
                      >{{ proposal.researcherLastName }}
                    </li>
                    <li>
                      <strong class="text-primary">تلفن همراه: </strong
                      >{{ proposal.researcherMobile }}
                    </li>
                    <li>
                      <strong class="text-primary">کدملی: </strong
                      >{{ proposal.researcherNatCode }}
                    </li>
                    <li>
                      <strong class="text-primary">پست الکترونیکی: </strong
                      >{{ proposal.researcherEmail }}
                    </li>
                    <li>
                      <strong class="text-primary">دورنگار: </strong
                      >{{ proposal.researcherFax }}
                    </li>
                    <li>
                      <strong class="text-primary">استان: </strong
                      >{{ proposal.researcherState }}
                    </li>
                    <li>
                      <strong class="text-primary">شهر: </strong
                      >{{ proposal.researcherCity }}
                    </li>
                    <li>
                      <strong class="text-primary"> دانشگاه محل تحصیل: </strong
                      >{{
                        proposal.researcherUniversityId
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li v-if="proposal.researcherUniversityId == notUniversity">
                      <strong class="text-primary">نام دانشگاه: </strong>
                      {{ proposal.researcherUniversityOther }}
                    </li>
                    <li class="'done'">
                      <strong class="text-primary"
                        >دانشگاه محل اشتغال به عنوان عضوهئیت علمی:
                      </strong>
                      {{
                        proposal.researcherUniversityJobId
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityJobId
                            )[0]
                            ? universities.filter(
                                (x) =>
                                  x.id == proposal.researcherUniversityJobId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li>
                      <strong class="text-primary">آخرین مدرک تحصیلی: </strong
                      >{{ proposal.researcherLastDegree }}
                    </li>
                    <b-form-group label="نشست های تخصصی برگزار شده:">
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.researcherMeetings"
                        :fields="meetingFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </b-form-group>
                    <b-form-group label="کارگاه های برگزار شده:">
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.researcherWorkshops"
                        :fields="workshopFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </b-form-group>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-4 variant="warning">
                <h5 class="mb-0" style="display: inline-block">
                  برگزار کنندگان
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <b-form-group>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.colleagues"
                      :fields="organizersFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </b-form-group>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-5 variant="light">
                <h5 class="mb-0" style="display: inline-block">زمان‌بندی</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-5"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3 shadow text-primary">
                  <b>زمان شروع:</b>
                  {{
                    proposal.gantData.length > 0
                      ? moment(
                          new Date(
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )
                          )
                        ).format("jYYYY/jMM/jDD")
                      : ""
                  }}
                  <br />
                  <b>زمان پایان:</b>
                  {{
                    proposal.gantData.length > 0
                      ? moment(
                          new Date(
                            Math.max(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )
                          )
                        ).format("jYYYY/jMM/jDD")
                      : ""
                  }}
                  <br />
                  <b>مدت زمان:</b>
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                  <br />
                  <br />
                  <div>
                    <sarmadGantt
                      :items="proposal.gantData"
                      :fields="serviceFields"
                    />
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-6 variant="dark">
                <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-6"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <b-form-group disabled>
                    <b-form-checkbox
                      :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[0]"
                      >با توجه به آیین نامه تمامی مستندات در پایان نشست در
                      سامانه بارگذاری خواهد شد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[1]"
                      >گزارش برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه
                      می شود.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[2]"
                      >عکس های برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد
                      ارائه می شود می‌باشد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[3]"
                      >پوستر نشست قبل از چاپ به تایید گروه پژوهش خواهد
                      رسید.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[4]"
                      >متن خبر پیش از برگزاری جهت درج در سایت به همراه پوستر
                      تایید شده به گروه پژوهش ارسال می شود.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[5]"
                      >هماهنگی مناسب با ناظر نشست صورت خواهد
                      گرفت.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[6]"
                      >پذیرایی از شرکت کنندگان طبق آیین نامه صورت خواهد
                      گرفت.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[7]"
                      >گواهی نامه ها طبق آیین نامه و با هماهنگی گروه پژوهش تهیه
                      و در اختیار شرکت کنندگان قرار می گیرد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[8]"
                      >لینک اخبار و مستندات و گزارش ها روی سامانه بارگذاری خواهد
                      شد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[9]"
                      >کتابچه برگزاری نشست با هماهنگی گروه پژوهش تهیه و در
                      اختیار ستاد قرار می گیرد.</b-form-checkbox
                    >
                  </b-form-group>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="fileFilter"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <!-- NOTE (b-delete) to delete the text of the search bar -->
                <b-button
                  :disabled="!fileFilter"
                  @click="fileFilter = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-files) to show the proposal files -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fileFields"
            :items="proposal.uploadedFiles.filter((x) => x && x.url != '')"
            :filter="fileFilter"
            empty-text="فایلی وجود ندارد"
            striped
            :busy="fileBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(url)="data">
              <div style="text-align: center; vertical-align: middle">
                <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
                <a
                  v-if="data.value"
                  class="btn btn-success"
                  :href="data.value"
                  target="_blank"
                  >دریافت فایل</a
                >
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong class="text-primary">در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-tab>
        <b-tab v-if="role == 'admin' || role == 'manager'" title="داوری">
          <!-- NOTE (t-review) to show the reviews list -->
          <b-table
            responsive
            small
            show-empty
            head-variant="dark"
            :items="reviews"
            :fields="judgementFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary my-3"
          >
            <template v-slot:cell(description)="row">
              <b-button
                size="sm"
                @click="row.toggleDetails"
                class="mr-2"
                :variant="row.detailsShowing ? 'danger' : 'success'"
                v-show="row.item.status == 'Done'"
                >{{ row.detailsShowing ? "بستن" : "نمایش" }} داوری</b-button
              >&nbsp;
              <!-- NOTE (b-expire) to expiration of the refree -->
              <b-button
                size="sm"
                @click="removeJudge(row)"
                variant="warning"
                class="mr-2"
                v-show="
                  row.item.status != 'Expired' &&
                  row.item.status != 'Done' &&
                  role != 'manager'
                "
                >انقضا داوری</b-button
              >
            </template>
            <template v-slot:row-details="row">
              <Review
                :disabled="true"
                :scoresData="row.item.scores"
                :refereeIdea="row.item.description"
                :refereeDecision="row.item.decisionEn"
              />
            </template>
            <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
            <template v-slot:cell(status)="data">
              {{ statusDictionary.find((x) => x.en == data.value).fa }}
            </template>
          </b-table>
        </b-tab>
        <b-tab v-if="role == 'admin' || role == 'manager'" title="تاریخچه">
          <b-card
            :bg-variant="computedVariant(index)"
            v-for="(p, index) in computedJournals"
            :key="index"
            style="max-width: 80%"
            class="mb-3 border-0 shadow"
          >
            <template slot="header">
              <b-row>
                <b-col>
                  <h5>{{ p.name }}</h5>
                </b-col>
                <b-col>
                  <div style="float: left">
                    <h5>{{ p.date }}</h5>
                  </div>
                </b-col>
              </b-row>
            </template>

            <h6>{{ p.message }}</h6>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="مدیریت وضعیت">
          <b-form-group id="fieldset-1" description label="وضعیت طرح">
            <b-form-group>
              <Select2
                v-model="selectedSituation"
                :options="situationsOptions"
                :settings="{ width: '75%' }"
              ></Select2>

              <!-- <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select> -->
            </b-form-group>
            <div v-if="selectedSituation == 8">
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  تذکر: لطفا توجه داشته باشد که متن نگارش شده توسط شما بدون
                  تغییر در اختیار کاربر قرار خواهد گرفت
                </p>
              </b-row>
            </div>
            <div v-if="selectedSituation == 3">
              <b-form-group label="داوران">
                <v-select
                  multiple
                  :reduce="(x) => x.code"
                  :options="reviewersOptions"
                  style="direction: rtl"
                  v-model="reviewers"
                >
                  <template v-slot:option="option">
                    <div class="text-right">
                      {{ option.label
                      }}<b-badge class="m-1 p-1" variant="info"
                        >کل {{ option.all }}</b-badge
                      ><b-badge class="m-1 p-1" variant="success"
                        >انجام شده {{ option.dones }}</b-badge
                      ><b-badge class="m-1 p-1" variant="danger"
                        >لغو شده {{ option.expireds }}</b-badge
                      ><b-badge class="m-1 p-1" variant="warning"
                        >در جریان {{ option.ongoings }}</b-badge
                      >
                    </div>
                  </template>
                </v-select>
              </b-form-group>
              <div v-if="reviewers.length">
                <div class="mb-2">داوران انتخاب شده</div>
                <div
                  class="selected-referees"
                  v-for="(item, index) in computedSelectedReferees"
                  :key="index"
                >
                  <v-card>
                    <v-card-title>{{ item.label }}</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col>داوری‌های دعوت شده: {{ item.all }}</v-col>
                        <v-col>داوری‌های انجام شده: {{ item.dones }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>داوری‌های در جریان: {{ item.ongoings }}</v-col>
                        <v-col>داوری‌های لغو شده: {{ item.expireds }}</v-col>
                      </v-row>
                      <v-row v-if="item.tags.length != 0">
                        <v-col class="selected-referees__tags">
                          <h6>برچسب‌های داور</h6>
                          <b-badge
                            class="tag"
                            v-for="(tag, index2) in item.tags"
                            :key="index2"
                            variant="primary"
                            >{{ tag }}</b-badge
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </div>
            <b-form-group
              label="دلایل رد درخواست"
              v-else-if="selectedSituation == 9"
            >
              <v-select
                multiple
                :reduce="(x) => x.code"
                :options="rejectOptions"
                v-model="proposal.rejectionIds"
              >
              </v-select>
            </b-form-group>
            <b-form-group v-else-if="selectedStatus == 3"></b-form-group>
            <b-form-group
              v-if="selectedSituation == 3"
              label="یادداشت برای داور:"
            >
              <b-form-textarea v-model="proposal.adminToReferee">
              </b-form-textarea>
            </b-form-group>
            <div v-if="selectedSituation == 7">
              <div>
                <b-row>
                  <b-col>
                    <h3 class="m-auto ml-4">وضعیت قرارداد</h3>
                    <br />

                    <b-form-radio-group v-model="contract">
                      <div class="d-flex" dir="rtl">
                        <b-form-radio :value="true"></b-form-radio>
                        <label class="ml-2 mt-1"
                          ><h6>شامل قرارداد می‌شود</h6></label
                        >
                      </div>
                      <div class="d-flex" dir="rtl">
                        <b-form-radio :value="false"></b-form-radio>
                        <label class="ml-2 mt-1"
                          ><h6>شامل قرارداد نمی‌شود</h6></label
                        >
                      </div>
                    </b-form-radio-group>
                  </b-col>
                  <b-col>
                    <h3 class="m-auto ml-4">ناظر</h3>
                    <br />

                    <b-form-radio-group v-model="haveReferee">
                      <div class="d-flex" dir="rtl">
                        <b-form-radio :value="true"></b-form-radio>
                        <label class="ml-2 mt-1"><h6>ناظر نیاز دارد</h6></label>
                      </div>
                      <div class="d-flex" dir="rtl">
                        <b-form-radio :value="false"></b-form-radio>
                        <label class="ml-2 mt-1"
                          ><h6>ناظر نیاز ندارد</h6></label
                        >
                      </div>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
                <div v-if="haveReferee">
                  <b-form-group label="ناظر مربوطه">
                    <v-select
                      :reduce="(x) => x.code"
                      :options="reviewersOptions"
                      style="direction: rtl"
                      v-model="selectedReferee"
                    >
                      <template v-slot:option="option">
                        <div class="text-right">
                          {{ option.label
                          }}<b-badge class="m-1 p-1" variant="info"
                            >کل {{ option.all }}</b-badge
                          ><b-badge class="m-1 p-1" variant="success"
                            >انجام شده {{ option.dones }}</b-badge
                          ><b-badge class="m-1 p-1" variant="danger"
                            >لغو شده {{ option.expireds }}</b-badge
                          ><b-badge class="m-1 p-1" variant="warning"
                            >در جریان {{ option.ongoings }}</b-badge
                          >
                        </div>
                      </template>
                    </v-select>
                  </b-form-group>
                  <div v-if="selectedReferee.length">
                    <div class="mb-2">ناظر انتخاب شده</div>
                    <div
                      class="selected-referees"
                      v-for="(item, index) in computedSelectedReferees2"
                      :key="index"
                    >
                      <v-card>
                        <v-card-title>{{ item.label }}</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col>داوری‌های دعوت شده: {{ item.all }}</v-col>
                            <v-col>داوری‌های انجام شده: {{ item.dones }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              >داوری‌های در جریان: {{ item.ongoings }}</v-col
                            >
                            <v-col
                              >داوری‌های لغو شده: {{ item.expireds }}</v-col
                            >
                          </v-row>
                          <v-row v-if="item.tags.length != 0">
                            <v-col class="selected-referees__tags">
                              <h6>برچسب‌های داور</h6>
                              <b-badge
                                class="tag"
                                v-for="(tag, index2) in item.tags"
                                :key="index2"
                                variant="primary"
                                >{{ tag }}</b-badge
                              >
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </div>

                <b-form-group label="یادداشت برای پژوهشگر:" class="mt-4">
                  <b-form-textarea
                    trim
                    id="textarea"
                    aria-describedby="adminMessage"
                    v-model="adminMessage"
                    width="75%"
                    rows="8"
                    max-rows="10"
                  ></b-form-textarea>
                </b-form-group>
              </div>

              <div>
                <h4 class="text-center text-dark">افزودن گزارش</h4>

                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addReport()"
                  ><strong>افزودن +</strong></b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="light"
                  :items="reportItems"
                  :fields="reportFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(date)="data">
                    <datePicker
                      color="#7b1fa2"
                      v-model="data.item.date"
                    ></datePicker>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="removeReport(data.index)"
                      >x</b-button
                    >
                  </template>
                </b-table>
                <hr />
                <h4 class="text-center text-dark">افزودن فایل</h4>

                <b-button variant="success" class="mb-3 ml-1" @click="addFile()"
                  ><strong>افزودن +</strong></b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="light"
                  :items="fileItems"
                  :fields="filesFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(date)="data">
                    <datePicker
                      color="#7b1fa2"
                      v-model="data.item.date"
                    ></datePicker>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="removeFile(data.index)"
                      >x</b-button
                    >
                  </template>
                </b-table>
              </div>
            </div>
            <b-form-group label="یادداشت" class="mt-4">
              <b-form-textarea
                trim
                id="textarea"
                v-model="proposal.description"
                :state="
                  selectedSituation == 8
                    ? proposal.description
                      ? null
                      : false
                    : null
                "
                width="75%"
                placeholder="نظرات خود را اینجا وارد نمایید"
                rows="8"
                max-rows="10"
              ></b-form-textarea>

              <b-form-invalid-feedback
                id="comments"
                :state="
                  selectedStatus == 'نیاز به تکمیل / اصلاح'
                    ? proposal.description
                      ? null
                      : false
                    : null
                "
                >با نوشتن نظر خود میتوانید پژوهشگر را در انجام اصلاحات مورد نیاز
                راهنمایی کنید</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group>
              <!-- NOTE (b-editProposal) to submit the proposal changes -->
              <b-button
                :disabled="disableEditProposal"
                @click="
                  editProposal(
                    situationsOptions.filter(
                      (x) => x.id == selectedSituation
                    )[0].eng
                  )
                "
                >ثبت</b-button
              >
            </b-form-group>
          </b-form-group>
        </b-tab>
        <b-tab v-if="proposal.isArchive" title="نسخه‌های پیشین">
          <b-tabs vertical pills fill>
            <b-tab v-for="(old, index) in proposal.archives" :key="index">
              <template slot="title">
                <div class="d-flex flex-column align-items-center">
                  {{ "نسخه" + " " + Number(proposal.archives.length - index) }}
                  <p class="mb-0">({{ old.registerDate }})</p>
                </div>
              </template>
              <b-tabs pills>
                <b-tab title="چکیده دوره‌" active lazy>
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-1 variant="dark">
                        <h5 class="mb-0">عنوان و حمایت‌های پیشین&nbsp;</h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-1"
                      accordion="my-accordion"
                      role="tabpanel"
                      visible
                    >
                      <b-card-body>
                        <b-card-text>
                          <ul>
                            <li>
                              <strong class="text-primary"
                                >عنوان به زبان فارسی: </strong
                              >{{ old.faSubject }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >آیا این طرح از حمایت‌های قبلی ستاد یا سایر
                                نهادها استفاده کرده است؟
                              </strong>
                              <b-form-radio-group
                                v-model="old.initialIsSupported"
                                disabled
                              >
                                <b-form-radio :value="true">بله</b-form-radio>
                                <b-form-radio :value="false">خیر</b-form-radio>
                              </b-form-radio-group>
                            </li>

                            <li v-if="old.initialIsSupported">
                              <strong class="text-primary">حمایت ها: </strong
                              >{{
                                old.initialSupportedType
                                  ? options.filter(
                                      (x) => x.value == old.initialSupportedType
                                    )[0].text
                                  : ""
                              }}
                            </li>
                            <li
                              v-if="
                                old.initialSupportedType == 'other' &&
                                old.initialIsSupported
                              "
                            >
                              <strong class="text-primary"
                                >عنوان حمایت دریافتی: </strong
                              >{{ old.initialOtherSupport }}
                            </li>
                            <li v-if="old.initialIsSupported">
                              <strong class="text-primary"
                                >توضیحات حمایت دریافتی: </strong
                              >{{ old.initialSupportDescription }}
                            </li>
                            <br />
                            <b-table
                              responsive
                              small
                              show-empty
                              head-variant="dark"
                              :items="old.meetingSponsors"
                              :fields="sponsorFields"
                              empty-text="رکوردی برای نمایش وجود ندارد"
                              class="table table-secondary"
                            >
                              <template v-slot:head()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.label }}
                                </div>
                              </template>
                              <template v-slot:cell()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.value }}
                                </div>
                              </template>
                              <template v-slot:cell(index)="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.index + 1 }}
                                </div>
                              </template>
                            </b-table>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-card-header
                      header-tag="header"
                      class="p-1 border-0"
                      role="tab"
                    >
                      <b-button block v-b-toggle.accordion-2 variant="dark">
                        <h5 class="mb-0" style="display: inline-block">
                          اطلاعات اصلی دوره
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-2"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <ul>
                            <li>
                              <strong class="text-primary"
                                >عنوان نشست تخصصی: </strong
                              >{{ old.faSubject }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >هدف از برگزاری نشست: </strong
                              >{{ old.meetingGoals }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >مکان برگزاری نشست: </strong
                              >{{ old.meetingPlace }}
                            </li>
                            <b-row class="text-primary pt-1 font-weight-bold">
                              <p class="mt-2 mr-2">
                                تاریخ برگزاری بین بازه زمانی
                              </p>
                              <span class="mt-2 mr-2">
                                {{ old.startDate }}</span
                              >
                              <p class="mt-2 mr-2">تا</p>
                              <span class="mt-2 mr-2">{{ old.finalDate }}</span>
                              <p class="mt-2 mr-2">می باشد</p>
                            </b-row>
                            <li>
                              <strong class="text-primary"
                                >دانشگاه محل برگزاری نشست:
                              </strong>
                              {{
                                old.universityId
                                  ? universities.filter(
                                      (x) => x.id == old.universityId
                                    )[0]
                                    ? universities.filter(
                                        (x) => x.id == old.universityId
                                      )[0].text
                                    : ""
                                  : ""
                              }}
                            </li>
                            <li v-if="old.universityId == notUniversity">
                              <strong class="text-primary">نام دانشگاه: </strong
                              >{{ old.otherUniversity }}
                            </li>
                            <li v-if="old.mehvarId != notMehvar">
                              <strong class="text-primary">محور طرح: </strong>
                              {{ mehvarr }}
                            </li>
                            <li v-if="old.mehvarId == notMehvar">
                              <strong class="text-primary">محور طرح: </strong>
                              سایر محورها
                            </li>
                            <li v-if="old.mehvarId == notMehvar">
                              <strong class="text-primary">نام محور: </strong
                              >{{ old.otherMehvars }}
                            </li>
                            <li>
                              <strong class="text-primary">حوزه طرح: </strong>
                              <b-form-group disabled>
                                <b-form-checkbox v-model="old.zoneMedicine"
                                  >پزشکی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneAgriculture"
                                  >کشاورزی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneEnvironment"
                                  >محیط زیست</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneIndustrial"
                                  >صنعتی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneBioComputing"
                                  >رایانش زیستی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneOther"
                                  >سایر</b-form-checkbox
                                >
                              </b-form-group>
                            </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-3 variant="light">
                        <h5 class="mb-0" style="display: inline-block">
                          اطلاعات مجری برگزار کننده نشست
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-3"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <ul>
                            <li>
                              <strong class="text-primary">نام: </strong
                              >{{ old.researcherName }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >نام خانوادگی: </strong
                              >{{ old.researcherLastName }}
                            </li>
                            <li>
                              <strong class="text-primary">تلفن همراه: </strong
                              >{{ old.researcherMobile }}
                            </li>
                            <li>
                              <strong class="text-primary">کدملی: </strong
                              >{{ old.researcherNatCode }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >پست الکترونیکی: </strong
                              >{{ old.researcherEmail }}
                            </li>
                            <li>
                              <strong class="text-primary">دورنگار: </strong
                              >{{ old.researcherFax }}
                            </li>
                            <li>
                              <strong class="text-primary">استان: </strong
                              >{{ old.researcherState }}
                            </li>
                            <li>
                              <strong class="text-primary">شهر: </strong
                              >{{ old.researcherCity }}
                            </li>
                            <li>
                              <strong class="text-primary">
                                دانشگاه محل تحصیل: </strong
                              >{{
                                old.researcherUniversityId
                                  ? universities.filter(
                                      (x) => x.id == old.researcherUniversityId
                                    )[0]
                                    ? universities.filter(
                                        (x) =>
                                          x.id == old.researcherUniversityId
                                      )[0].text
                                    : ""
                                  : ""
                              }}
                            </li>
                            <li
                              v-if="old.researcherUniversityId == notUniversity"
                            >
                              <strong class="text-primary"
                                >نام دانشگاه:
                              </strong>
                              {{ old.researcherUniversityOther }}
                            </li>
                            <li class="'done'">
                              <strong class="text-primary"
                                >دانشگاه محل اشتغال به عنوان عضوهئیت علمی:
                              </strong>
                              {{
                                old.researcherUniversityJobId
                                  ? universities.filter(
                                      (x) =>
                                        x.id == old.researcherUniversityJobId
                                    )[0]
                                    ? universities.filter(
                                        (x) =>
                                          x.id == old.researcherUniversityJobId
                                      )[0].text
                                    : "-"
                                  : "-"
                              }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >آخرین مدرک تحصیلی: </strong
                              >{{ old.researcherLastDegree }}
                            </li>
                            <b-form-group label="نشست های تخصصی برگزار شده:">
                              <b-table
                                responsive
                                small
                                show-empty
                                head-variant="dark"
                                :items="old.researcherMeetings"
                                :fields="meetingFields"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.index + 1 }}
                                  </div>
                                </template>
                              </b-table>
                            </b-form-group>
                            <b-form-group label="کارگاه های برگزار شده:">
                              <b-table
                                responsive
                                small
                                show-empty
                                head-variant="dark"
                                :items="old.researcherWorkshops"
                                :fields="workshopFields"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.index + 1 }}
                                  </div>
                                </template>
                              </b-table>
                            </b-form-group>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-4 variant="warning">
                        <h5 class="mb-0" style="display: inline-block">
                          برگزار کنندگان
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-4"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <b-form-group>
                            <b-table
                              responsive
                              small
                              show-empty
                              head-variant="dark"
                              :items="old.colleagues"
                              :fields="organizersFields"
                              empty-text="رکوردی برای نمایش وجود ندارد"
                              class="table table-secondary"
                            >
                              <template v-slot:head()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.label }}
                                </div>
                              </template>
                              <template v-slot:cell()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.value }}
                                </div>
                              </template>
                              <template v-slot:cell(index)="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.index + 1 }}
                                </div>
                              </template>
                            </b-table>
                          </b-form-group>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-5 variant="light">
                        <h5 class="mb-0" style="display: inline-block">
                          زمان‌بندی
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-5"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="p-3 shadow text-primary">
                          <b>زمان شروع:</b>
                          {{
                            old.gantData.length > 0
                              ? moment(
                                  new Date(
                                    Math.min(
                                      ...old.gantData.map((x) =>
                                        new Date(
                                          moment(
                                            x.startDate,
                                            "jYYYY/jMM/jDD"
                                          ).format("YYYY-MM-DD")
                                        ).getTime()
                                      )
                                    )
                                  )
                                ).format("jYYYY/jMM/jDD")
                              : ""
                          }}
                          <br />
                          <b>زمان پایان:</b>
                          {{
                            old.gantData.length > 0
                              ? moment(
                                  new Date(
                                    Math.max(
                                      ...old.gantData.map((x) =>
                                        new Date(
                                          moment(
                                            x.dueDate,
                                            "jYYYY/jMM/jDD"
                                          ).format("YYYY-MM-DD")
                                        ).getTime()
                                      )
                                    )
                                  )
                                ).format("jYYYY/jMM/jDD")
                              : ""
                          }}
                          <br />
                          <b>مدت زمان:</b>
                          {{
                            old.gantData.length > 0
                              ? (Math.max(
                                  ...old.gantData.map((x) =>
                                    new Date(
                                      moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                        "YYYY-MM-DD"
                                      )
                                    ).getTime()
                                  )
                                ) -
                                  Math.min(
                                    ...old.gantData.map((x) =>
                                      new Date(
                                        moment(
                                          x.startDate,
                                          "jYYYY/jMM/jDD"
                                        ).format("YYYY-MM-DD")
                                      ).getTime()
                                    )
                                  )) /
                                  3600 /
                                  24 /
                                  1000 +
                                " روز"
                              : ""
                          }}
                          <br />
                          <div>
                            <sarmadGantt
                              :items="old.gantData"
                              :fields="serviceFields"
                            />
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-6 variant="dark">
                        <h5 class="mb-0" style="display: inline-block">
                          تعهدات
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-6"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <b-form-group disabled>
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[0] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[0]"
                              >با توجه به آیین نامه تمامی مستندات در پایان نشست
                              در سامانه بارگذاری خواهد شد.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[1] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[1]"
                              >گزارش برگزاری نشست طی 24 ساعت جهت درج در سایت
                              ستاد ارائه می شود.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[2] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[2]"
                              >عکس های برگزاری نشست طی 24 ساعت جهت درج در سایت
                              ستاد ارائه می شود می‌باشد.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[3] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[3]"
                              >پوستر نشست قبل از چاپ به تایید گروه پژوهش خواهد
                              رسید.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[4] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[4]"
                              >متن خبر پیش از برگزاری جهت درج در سایت به همراه
                              پوستر تایید شده به گروه پژوهش ارسال می
                              شود.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[5] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[5]"
                              >هماهنگی مناسب با ناظر نشست صورت خواهد
                              گرفت.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[6] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[6]"
                              >پذیرایی از شرکت کنندگان طبق آیین نامه صورت خواهد
                              گرفت.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[7] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[7]"
                              >گواهی نامه ها طبق آیین نامه و با هماهنگی گروه
                              پژوهش تهیه و در اختیار شرکت کنندگان قرار می
                              گیرد.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[8] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[8]"
                              >لینک اخبار و مستندات و گزارش ها روی سامانه
                              بارگذاری خواهد شد.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[9] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[9]"
                              >کتابچه برگزاری نشست با هماهنگی گروه پژوهش تهیه و
                              در اختیار ستاد قرار می گیرد.</b-form-checkbox
                            >
                          </b-form-group>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-tab>
                <b-tab title="فایل های تکمیلی">
                  <h6>
                    <b-input-group size="md">
                      <b-form-input
                        trim
                        v-model="fileFilter"
                        type="search"
                        id="filterInput"
                        placeholder="جستجو"
                      ></b-form-input>
                      <b-input-group-append>
                        <!-- NOTE (b-delete) to delete the text of the search bar -->
                        <b-button
                          :disabled="!fileFilter"
                          @click="fileFilter = ''"
                          variant="danger"
                          >حذف</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </h6>

                  <!-- NOTE (t-files) to show the old files -->
                  <b-table
                    responsive
                    show-empty
                    head-variant="dark"
                    :fields="fileFields"
                    :items="old.uploadedFiles.filter((x) => x && x.url != '')"
                    :filter="fileFilter"
                    empty-text="فایلی برای نمایش وجود ندارد"
                    empty-filtered-text="فایلی  برای نمایش وجود ندارد"
                    striped
                    :busy="fileBusy"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(url)="data">
                      <div style="text-align: center; vertical-align: middle">
                        <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
                        <a
                          v-if="data.value"
                          class="btn btn-success"
                          :href="data.value"
                          target="_blank"
                          >دریافت فایل</a
                        >
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <strong class="text-primary">در حال بارگذاری...</strong>
                      <br />
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </b-table>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab
          v-if="role == 'manager' && proposal.status == 'پذیرش اولیه'"
          title="مدیریت وضعیت"
        >
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">مدیریت وضعیت&nbsp;</h4>
            </template>

            <b-form-group
              id="fieldset-1"
              description
              label="وضعیت طرح"
              aria-invalid="comments"
            >
              <b-form-group>
                <Select2
                  v-model="selectedSituation"
                  :options="[
                    { id: 'finalAccept', text: 'تایید نهایی' },
                    { id: 'rejected', text: 'رد شده است' },
                  ]"
                  :settings="{ width: '75%' }"
                ></Select2>
                <!-- <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select> -->
              </b-form-group>

              <b-form-group
                label="دلایل رد درخواست"
                v-if="selectedSituation == 'rejected'"
              >
                <v-select
                  multiple
                  :reduce="(x) => x.code"
                  :options="rejectOptions"
                  v-model="rejectCause"
                >
                </v-select>
              </b-form-group>
              <b-form-group v-else-if="selectedStatus == 3"></b-form-group>

              <b-form-group>
                <!-- NOTE (b-rejection) to submit reason for rejection -->
                <b-button
                  :disabled="disableEditProposal"
                  @click="editProposalManager"
                  >ثبت</b-button
                >
              </b-form-group>
            </b-form-group>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'referee'" title="داوری">
          <Review />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
// NOTE (FUNCTION) to check validation of the email address

import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import Review from "./MeetingReview"; // NOTE (IMPORT) to use reviewing component
import { EventBus } from "../main"; // REVIEW
const sarmadGantt = () => import("./sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  name: "Meeting",
  props: ["role"],
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    Review,
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      oldData: [],
      expireDisable: false,
      adminToReferee: "",
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",

      moment: moment,
      checkbox: "",
      checkbox2: "",
      show: false,
      busy: false,
      fileBusy: false,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      acc: 0,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      selectedColleague: "",
      executor: {},
      proposal: {
        initialIsSupported: null,
      },
      pageLoaded: false,
      promises: {},
      colleague: {},
      universities: [],
      mehvars: [],
      dateFrom: moment(new Date()).format("jYYYY/jMM/jDD"),
      dateTo: moment(new Date()).format("jYYYY/jMM/jDD"),
      zone: new Array(6).fill(false),
      achievmentitems: [],
      tabIndex: 0,
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      rejectMessage: "",
      dr: {},
      selectedMehvar: 0,
      taahol: "",
      isLoaded: true,
      DoiItem: [],
      inputs: [
        {
          name: "",
        },
      ],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      inventionItem: [],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "year", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      sponsorFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام حامی" },
      ],
      file: null,
      fileFilter: "",
      OrgCostItem: [],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],

      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
        { key: "operation", label: "" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        research: { uploadPercentage: 0 },
        industry: { uploadPercentage: 0 },
        agreement: { uploadPercentage: 0 },
        others1: { uploadPercentage: 0 },
        others2: { uploadPercentage: 0 },
        others3: { uploadPercentage: 0 },
      },
      meetingFields: [
        { key: "index", label: "ردیف" },
        { key: "meetingSubject", label: "عنوان نشست" },
        { key: "meetingPlace", label: "محل برگزاری" },
        { key: "meetingDate", label: "تاریخ برگزاری" },
        { key: "supporterOrg", label: "سازمان حمایت کننده" },
      ],
      workshopFields: [
        { key: "index", label: "ردیف" },
        { key: "workshopSubject", label: "عنوان کارگاه برگزار شده" },
        { key: "workshopPlace", label: "محل برگزاری" },
        { key: "workshopDate", label: "تاریخ برگزاری" },
        { key: "workshopSupporterOrg", label: "سازمان حمایت کننده" },
      ],
      organizersFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "lastName", label: "نام خانوادگی" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "position", label: "سمت" },
        { key: "mobile", label: "شماره تماس" },
        { key: "email", label: "ایمیل" },
      ],
      config: {
        locale: {
          name: "en",
        },
        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      reviewers: [],
      situationsOptions: [
        {
          id: 12,
          eng: "draf",
          text: "پیش نویس",
          disabled: true,
        },
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
    };
  },

  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$root.$emit("show::modal", "loading");

      this.busyAll = true;

      this.fileBusy = false;
      // rejections
      this.$http
        .post(
          this.baseUrl + "/setad/options/rejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.rejectOptions = res.data;
          this.rejectOptions.forEach((x) => {
            x.code = x.id;
            x.label = x.name;
          });

          acc++;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      if (this.role == "admin") {
        let acc = 0;
        // admin universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              name: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin reviewers
        this.$http
          .post(
            this.baseUrl + "/setad/admin/reviewers/select",
            {
              projectId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.reviewersOptions = res.data;
            this.reviewersOptions.forEach((x) => {
              x.code = x.id;
              x.label = x.name;
            });

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        //////////////////////////////////////
        // admin getInfo
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/meeting/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.reviews = res.data.reviews;
            this.selectedSituation = this.situationsOptions.filter(
              (x) => x.text == this.proposal.status
            )[0].id;
            acc++;
            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "researcher") {
        let acc = 0;
        // NOTE (MOUNTED) to show the profile of user

        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/meeting/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                try {
                  this.toast(
                    "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                  );
                } catch (error) {
                  console.log(error);
                }
              } catch {}
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);

            // this.additionalFiles = JSON.parse(res.data.project.files);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        this.$bvModal.show("loading");
        this.isLoaded = false;
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                try {
                  this.toast(
                    "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                  );
                } catch (error) {
                  console.log(error);
                }
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                try {
                  this.toast(
                    "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                  );
                } catch (error) {
                  console.log(error);
                }
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "referee") {
        let acc = 0;
        // referee universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");

                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // referee mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        /////////////////////////////////////////////
        // referee companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        //////////////////////////////////////
        // referee getInfo
        this.$http
          .post(
            this.baseUrl + "/setad/reviewer/review/meeting/getInfo",
            {
              reviewId: this.$route.params.judgeId,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.proposal.adminToReferee = res.data.adminToReferee;

            this.acc++;
            this.$bvModal.hide("loading");
            this.pageLoaded = true;
            this.isLoaded = true;
            if (this.acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            this.refereeErrorHandler = true;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "manager") {
        let allUniMehvars = this.$http.post(
          this.baseUrl + "/setad/manager/allUniMehvarsBoth",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );
        let allUniversities = this.$http.post(
          this.baseUrl + "/setad/manager/allUniversities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );

        Promise.all([allUniMehvars, allUniversities]).then((res) => {
          let allMehv = res[0].data;
          let allUni = res[1].data;

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.mehvars = allMehv;
          this.mehvars.push(
            new Object({
              id: this.notMehvar,
              text: "سایر محورها",
              universityId: this.notUniversity,
            })
          );

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.universities = allUni;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه‌ها",
            })
          );
        });
      } else if (this.role == "head") {
        let acc = 0;

        // head universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              name: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head reviewers
        this.$http
          .post(
            this.baseUrl + "/setad/head/reviewers/select",
            {
              projectId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.reviewersOptions = res.data;
            this.reviewersOptions.forEach((x) => {
              x.code = x.id;
              x.label = x.name;
            });

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        //////////////////////////////////////
        // head getInfo

        this.fileBusy = false;
        this.$http
          .post(
            this.baseUrl + "/setad/head/request/meeting/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.files = res.data.uploadedFiles;
            // this.pageLoaded = true;
            acc++;
            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.pageLoaded = true;
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.notLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "university") {
        let acc = 0;
        // NOTE (MOUNTED) to show the profile of user

        this.$http
          .post(
            this.baseUrl + "/setad/university/request/meeting/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                try {
                  this.toast(
                    "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                  );
                } catch (error) {
                  console.log(error);
                }
              } catch {}
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);

            // this.additionalFiles = JSON.parse(res.data.project.files);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        this.$bvModal.show("loading");
        this.isLoaded = false;
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                try {
                  this.toast(
                    "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                  );
                } catch (error) {
                  console.log(error);
                }
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                try {
                  this.toast(
                    "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                  );
                } catch (error) {
                  console.log(error);
                }
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
      // this.showProject();
    },
    getManagerInfo() {
      // NOTE (m-getManagerInfo) to get the proposal information and review details
      let rejectsPromise = this.$http.post(
        this.baseUrl + "/setad/manager/allrejections ",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        }
      );

      rejectsPromise.then((res3) => {
        this.rejectOptions.push(
          ...res3.data.map((x) => {
            return {
              code: x.id,
              label: x.name,
            };
          })
        );
      });
      this.$http
        .post(
          this.baseUrl + "/setad/manager/requestId",
          {
            projectId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          try {
            this.judgements = JSON.parse(res.data.project.judgements);
          } catch (error) {
            this.judgements = [];
          }

          try {
            this.reviewerData = JSON.parse(res.data.project.reviewer);
          } catch (error) {
            this.reviewerData = [];
          }

          this.proposal = res.data.project;

          try {
            this.initial = JSON.parse(res.data.project.initial);
          } catch (error) {
            this.initial = {};
          }
          try {
            this.promises = JSON.parse(res.data.project.promises);
          } catch (error) {
            this.promises = {};
          }
          this.executor = JSON.parse(res.data.project.secondStep);

          this.uploadedFiles = res.data.project.files;

          this.proposalStudies = JSON.parse(this.proposal.type).studies;
          this.proposalDevelopment = JSON.parse(this.proposal.type).development;
          this.proposalPractical = JSON.parse(this.proposal.type).practical;
          this.proposal.zoneMedicine = JSON.parse(this.proposal.zone).zone1;
          this.proposal.zoneAgriculture = JSON.parse(this.proposal.zone).zone2;
          this.proposal.zoneEnvironment = JSON.parse(this.proposal.zone).zone3;
          this.proposal.zoneIndustrial = JSON.parse(this.proposal.zone).zone4;
          this.proposal.zoneBioComputing = JSON.parse(this.proposal.zone).zone5;
          this.proposal.zoneOther = JSON.parse(this.proposal.zone).zone6;

          this.proposal.otherUniversity = JSON.parse(
            res.data.project.description
          ).proposal.otherUniversity;
          this.proposal.otherMehvars = JSON.parse(
            res.data.project.description
          ).proposal.otherMehvars;

          this.colleaguesData = JSON.parse(res.data.project.thirdStep);
          this.specs = JSON.parse(res.data.project.fourthStep).specs;

          this.achievmentitems = JSON.parse(
            res.data.project.fourthStep
          ).tables.achievmentitems;
          this.proposal.gantData = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.gantData;
          this.PersonnelCostItem = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.gantData;

          /////////////////////////////////////////////////////////////////////
          // تنها جایی از mounted که تغییر میکند با توجه به جداول مربوطه //
          /////////////////////////////////////////////////////////////////////

          this.proposal.meetingSponsors = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.meetingSponsors;

          this.proposal.researcherMeetings = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.researcherMeetings;

          this.proposal.researcherWorkshops = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.researcherWorkshops;

          this.proposal.colleagues = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.colleagues;

          this.show = false;

          this.acc++;

          if (this.acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              try {
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch (error) {
                console.log(error);
              }
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.show = true;
          }, 200);

          this.fileBusy = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log({ err });
        });
    },
    hideModal(type) {
      // NOTE (m-hideModal) to hide loading
      this.$refs[type].hide();
    },
    removeJudge(row) {
      // NOTE (m-removeJudge) to specify selected judgment
      this.selectedJudgement = row.item;
      this.$root.$emit("show::modal", "delJudge");
      this.$bvModal.show("delJudge");
    },
    delJudge() {
      // NOTE (m-delJudge) to delete judgment
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/expireReview",
          {
            reviewId: this.selectedJudgement.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.$bvModal.hide("delJudge");
          this.onMounted();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    computedVariant(seed) {
      // REVIEW
      let variant = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "dark",
        "info",
        "light",
      ];
      return variant[seed % 8];
    },
    sendReview() {
      // NOTE (m-sendReview) to submit the judgment
      this.$http
        .post(
          this.baseUrl + "/setad/referee/addJudge",
          {
            judgeId: this.selectedJudgement.id,
            description: this.score,
            decision: this.refereeDecision,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            EventBus.$emit("refereeAdded", {});
            this.$router.replace("/referee/reviews");
          } else if (res.status == 202) {
            this.toast(res.data.text, "success");
            this.toast(res.data.error, "error");
            this.$router.replace("/referee/reviews");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });

      this.fileBusy = false;
    },
    editProposal(status) {
      // NOTE (m-editProposal) to submit proposal changes
      this.$bvModal.show("loading");

      if (status == "inviteReviewers") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/meeting/" + status,
            {
              requestId: this.$route.params.id,
              description: this.proposal.description,
              referees: this.reviewers,
              adminToReferee: this.proposal.adminToReferee,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              this.$router.push("/admin/activeMeetings");
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (status == "finalAccept") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/meeting/" + status,
            {
              requestId: this.$route.params.id,
              contract: this.contract,
              isReferee: this.haveReferee,
              reports: this.reportItems,
              pcFiles: this.fileItems,
              refereeId: this.selectedReferee,
              adminMessage: this.adminMessage,
              description: this.proposal.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              this.$router.push("/admin/decidedMeetings");
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (status == "reject") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/meeting/" + status,
            {
              requestId: this.$route.params.id,
              rejectionIds: this.proposal.rejectionIds,
              description: this.proposal.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              this.$router.push("/admin/canceledMeetings");
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/meeting/" + status,
            {
              requestId: this.$route.params.id,
              description: this.proposal.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
              if (this.selectedSituation == 8) {
                this.$router.push("/admin/needEditMeetings");
              } else {
                this.$router.push("/admin/activeMeetings");
              }
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    submitComment() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/editRequestId",
          {
            projectId: this.$route.params.id,
            projectType: "meeting",
            description: JSON.stringify({
              description: this.comments,
              score: this.score,
            }),
            rejection_id: JSON.stringify(this.rejectCause),
            situation: this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].eng,
            referees:
              this.reviewersData.length > 1
                ? String(this.reviewersData)
                : this.reviewersData.length
                ? String(this.reviewersData[0])
                : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        ) // REVIEW
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.acc = 2;
            setTimeout(() => {
              this.showProject();
            }, 300);
            this.comments = "";
            this.toast(res.data, "success");
          }
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    editProposalManager() {
      // NOTE (m-editProposalManager) to submit reason for rejection
      this.$bvModal.show("loading");
      this.isLoaded = false;
      let editProposal = this.$http.post(
        this.baseUrl + "/setad/manager/confirmationRequestId",
        {
          projectId: this.$route.params.id,
          projectType: "meeting",
          rejection_id: JSON.stringify(this.rejectCause),
          situation: this.selectedSituation,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        }
      );

      editProposal // REVIEW
        .then((res) => {
          this.proposal.status = this.selectedSituation;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.$router.push("/manager/needMeetings");
          }
        })
        .catch((err) => {
          this.getManagerInfo();
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    //haveContract() {
    //  if (this.fileItems.filter((x) => x.title == "قرارداد").length == 0) {
    //    this.fileItems.unshift({
    //      title: "قرارداد",
    //      date: moment(new Date()).format("jYYYY/jMM/jDD"),
    //    });
    //  }
    //},
    //dontHaveContract() {
    //  if (this.fileItems.filter((x) => x.title == "قرارداد").length != 0) {
    //    this.fileItems.splice(
    //      this.fileItems.indexOf(
    //        this.fileItems.filter((x) => x.title == "قرارداد")[0]
    //      ),
    //      1
    //    );
    //  }
    //},
    addReport() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.reportItems.push({
        name: "گزارش " + Number(this.reportItems.length + 1),
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
      });
    },
    removeReport(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.reportItems.splice(order, 1);
      const title = (
        <div>
          <h5>حذف گزارش</h5>
          <span>گزارش مورد نظر شما حذف شد</span>
        </div>
      );
      this.toast(title, "error");
    },
    addFile() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.fileItems.push({
        title: "فایل " + Number(this.fileItems.length + 1),
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
      });
    },
    removeFile(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.fileItems.splice(order, 1);
      const title = (
        <div>
          <h5>حذف فایل</h5>
          <span>فایل مورد نظر شما حذف شد</span>
        </div>
      );
      this.toast(title, "error");
    },
    showProject() {
      if (this.role == "researcher") {
        let rejectsPromise = this.$http.post(
          this.baseUrl + "/setad/researcher/allrejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );

        rejectsPromise.then((res3) => {
          this.rejectOptions.push(
            ...res3.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        });
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/showProject",
            {
              projectId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.project;
            try {
              this.initial = JSON.parse(res.data.project.initial);
            } catch (error) {
              this.initial = {};
            }
            this.promises = JSON.parse(res.data.project.promises);
            try {
              this.errorMessage = JSON.parse(
                this.proposal.adminMessage
              ).description;
            } catch (error) {
              this.errorMessage = this.proposal.adminMessage;
            }
            try {
              this.rejectMessage = JSON.parse(this.proposal.rejection);
            } catch (error) {
              this.rejectMessage = [];
            }
            try {
              this.reviewerData = JSON.parse(res.data.project.reviewer);
            } catch (error) {
              this.reviewerData = [];
            }
            this.executor = JSON.parse(res.data.project.secondStep);

            this.uploadedFiles = res.data.project.files;

            this.proposalStudies = JSON.parse(this.proposal.type).studies;
            this.proposalDevelopment = JSON.parse(
              this.proposal.type
            ).development;
            this.proposalPractical = JSON.parse(this.proposal.type).practical;
            this.proposal.zoneMedicine = JSON.parse(this.proposal.zone).zone1;
            this.proposal.zoneAgriculture = JSON.parse(
              this.proposal.zone
            ).zone2;
            this.proposal.zoneEnvironment = JSON.parse(
              this.proposal.zone
            ).zone3;
            this.proposal.zoneIndustrial = JSON.parse(this.proposal.zone).zone4;
            this.proposal.zoneBioComputing = JSON.parse(
              this.proposal.zone
            ).zone5;
            this.proposal.zoneOther = JSON.parse(this.proposal.zone).zone6;

            this.proposal.otherUniversity = JSON.parse(
              res.data.project.description
            ).proposal.otherUniversity;
            this.proposal.otherMehvars = JSON.parse(
              res.data.project.description
            ).proposal.otherMehvars;

            this.colleaguesData = JSON.parse(res.data.project.thirdStep);
            this.specs = JSON.parse(res.data.project.fourthStep).specs;

            this.achievmentitems = JSON.parse(
              res.data.project.fourthStep
            ).tables.achievmentitems;
            this.proposal.gantData = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.gantData;
            this.PersonnelCostItem = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.gantData;

            /////////////////////////////////////////////////////////////////////
            // تنها جایی از mounted که تغییر میکند با توجه به جداول مربوطه //
            /////////////////////////////////////////////////////////////////////

            this.proposal.meetingSponsors = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.meetingSponsors;

            this.proposal.researcherMeetings = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.researcherMeetings;

            this.proposal.researcherWorkshops = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.researcherWorkshops;

            this.proposal.colleagues = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.colleagues;

            this.show = false;
            this.config.height = this.proposal.gantData.length * 60 + 100;

            this.config.list.rows = new Object({});
            this.config.chart.items = new Object({});
            this.uploadedFiles.forEach((x, index) => {
              if (x) this["myTempFile" + index] = true;
              else this["myTempFile" + index] = false;
            });
            this.proposal.gantData.forEach((x, index) => {
              this.config.list.rows[JSON.stringify(index + 1)] = new Object({
                id: JSON.stringify(index + 1),
                label: x.description,
              });

              this.config.chart.items[JSON.stringify(index + 1)] = new Object({
                id: JSON.stringify(index + 1),
                rowId: JSON.stringify(index + 1),
                label: x.description,
                time: {
                  start: new Date(
                    moment(x.startDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
                  ).getTime(),
                  end: new Date(
                    moment(x.dueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
                  ).getTime(),
                },
                style: {
                  background: this.background[index],
                },
              });
            });
            this.acc++;

            if (this.acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                try {
                  this.toast(
                    "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                  );
                } catch (error) {
                  console.log(error);
                }
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            if (err.response.status == 403) {
              if (err.response.data == "expired")
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
              // else this.$router.replace("/unauthorize");
              else
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
            }
          });
      } else if (this.role == "referee") {
        this.$http
          .post(
            this.baseUrl + "/setad/referee/refereeShowProject",
            {
              projectId: this.$route.params.id,
              judgeId: this.$route.params.judgeId,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.project;
            this.adminToReferee = res.data.project.adminToReferee;
            try {
              this.initial = JSON.parse(res.data.project.initial);
            } catch (error) {
              this.initial = {};
            }
            this.promises = JSON.parse(res.data.project.promises);

            try {
              this.reviewerData = JSON.parse(res.data.project.reviewer);
            } catch (error) {
              this.reviewerData = [];
            }
            this.executor = JSON.parse(res.data.project.secondStep);

            this.uploadedFiles = res.data.project.files;

            this.proposalStudies = JSON.parse(this.proposal.type).studies;
            this.proposalDevelopment = JSON.parse(
              this.proposal.type
            ).development;
            this.proposalPractical = JSON.parse(this.proposal.type).practical;
            this.proposal.zoneMedicine = JSON.parse(this.proposal.zone).zone1;
            this.proposal.zoneAgriculture = JSON.parse(
              this.proposal.zone
            ).zone2;
            this.proposal.zoneEnvironment = JSON.parse(
              this.proposal.zone
            ).zone3;
            this.proposal.zoneIndustrial = JSON.parse(this.proposal.zone).zone4;
            this.proposal.zoneBioComputing = JSON.parse(
              this.proposal.zone
            ).zone5;
            this.proposal.zoneOther = JSON.parse(this.proposal.zone).zone6;

            this.proposal.otherUniversity = JSON.parse(
              res.data.project.description
            ).proposal.otherUniversity;
            this.proposal.otherMehvars = JSON.parse(
              res.data.project.description
            ).proposal.otherMehvars;

            this.colleaguesData = JSON.parse(res.data.project.thirdStep);
            this.specs = JSON.parse(res.data.project.fourthStep).specs;

            this.achievmentitems = JSON.parse(
              res.data.project.fourthStep
            ).tables.achievmentitems;
            this.proposal.gantData = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.gantData;
            this.PersonnelCostItem = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.gantData;

            /////////////////////////////////////////////////////////////////////
            // تنها جایی از mounted که تغییر میکند با توجه به جداول مربوطه //
            /////////////////////////////////////////////////////////////////////

            this.proposal.meetingSponsors = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.meetingSponsors;

            this.proposal.researcherMeetings = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.researcherMeetings;

            this.proposal.researcherWorkshops = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.researcherWorkshops;

            this.proposal.colleagues = JSON.parse(
              res.data.project.fourthStep
            ).tables.proposal.colleagues;

            this.show = false;

            this.acc++;

            if (this.acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                try {
                  this.toast(
                    "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                  );
                } catch (error) {
                  console.log(error);
                }
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            this.refereeErrorHandler = true;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "manager") {
        this.getManagerInfo();
      }
    },
  },
  computed: {
    computedSelectedReferees() {
      let referees = this.reviewersOptions.filter(
        (x) => this.reviewers.indexOf(x.code) != -1
      );
      return referees;
    },
    computedSelectedReferees2() {
      let referees = this.reviewersOptions.filter(
        (x) => this.selectedReferee.indexOf(x.code) != -1
      );
      return referees;
    },
    mehvarr() {
      let mehvarr;
      try {
        mehvarr = this.mehvars.filter((x) => x.id == this.proposal.mehvarId)[0]
          .text;
      } catch (error) {
        mehvarr = "";
      }
      return mehvarr;
    },
    computedOldData() {
      try {
        this.oldData.splice(this.oldData.length - 1, 1);
        return this.oldData;
      } catch (error) {
        return [];
      }
    },
    computedJournals() {
      if (this.proposal.history) {
        return this.proposal.history.sort((a, b) => {
          if (a.timeStamp < b.timeStamp) {
            return 1;
          }
          if (a.timeStamp > b.timeStamp) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
    computedJudgements() {
      if (this.proposal.judgements) {
        this.proposal.judgements.forEach((element) => {
          this.$set(element, "_showDetails", false);
          this.$set(element, "isActive", false);
        });

        return this.proposal.judgements;
      } else return [];
    },
    disableEditProposal() {
      if (this.selectedSituation) {
        if (this.selectedSituation == 8) {
          if (!this.proposal.description) {
            return true;
          } else return false;
        }
        if (this.selectedSituation == 7) {
          if (
            this.contract == null ||
            this.haveReferee == null ||
            !this.reportItems.length
          ) {
            return true;
          } else if (this.haveReferee && this.selectedReferee.length == 0) {
            return true;
          } else return false;
        }
        if (this.selectedSituation == 3 && this.reviewers.length == 0)
          return true;
        if (this.selectedSituation == 9 && !this.proposal.rejectionIds.length)
          return true;
        if (this.selectedSituation == 10 && !this.proposal.description)
          return true;
        return false;
      } else return true;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.onMounted();
  },
  updated() {},
};
</script>
<style lang="scss" scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  h5 {
    color: #fff !important;
  }
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  h5 {
    color: #fff !important;
  }
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  h5 {
    color: #fff !important;
  }
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  h5 {
    color: #fff !important;
  }
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  h5 {
    color: #fff !important;
  }
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

#vs1__listbox {
  text-align: right;
  direction: rtl;
}
</style>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
